// <s-article-toc>: builds an "In this story" list from the article body's h2 headings and highlights the one in view.
class ArticleToc extends HTMLElement {
  connectedCallback() {
    const body = document.querySelector(this.dataset.target || '[data-article-body]');
    const list = this.querySelector('[data-toc-list]');
    if (!body || !list) return;
    const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    if (headings.length < 2) return;

    const used = new Set();
    const links = headings.map((heading) => {
      if (!heading.id) {
        let slug = heading.textContent.trim().toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'section';
        let id = slug;
        let n = 2;
        while (used.has(id) || document.getElementById(id)) id = `${slug}-${n++}`;
        heading.id = id;
      }
      used.add(heading.id);
      heading.classList.add('scroll-mt-32');
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${heading.id}`;
      a.textContent = heading.textContent.trim();
      a.className = 'block border-s border-border ps-4 py-1.5 text-sm leading-snug text-on-surface-secondary no-underline hover:text-on-surface aria-[current=true]:border-on-surface aria-[current=true]:text-on-surface motion-safe:transition-colors';
      li.append(a);
      list.append(li);
      return a;
    });
    this.hidden = false;

    const byId = new Map(links.map((a) => [a.hash.slice(1), a]));
    const setCurrent = (id) => links.forEach((a) => a.setAttribute('aria-current', a.hash.slice(1) === id ? 'true' : 'false'));
    setCurrent(headings[0].id);
    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0] && byId.has(visible[0].target.id)) setCurrent(visible[0].target.id);
      },
      { rootMargin: '0px 0px -70% 0px' }
    );
    headings.forEach((h) => this.observer.observe(h));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-article-toc')) customElements.define('s-article-toc', ArticleToc);
